<template>
  <div class="PlatformDetail">
    <div class="bg_black text_white">
      <div class="" style="padding-left:10px">
        <van-nav-bar
          :title="$t('itemInfo.itemdetail')"
          left-arrow
          fixed
          @click-left="$router.go(-1)"
        >
        </van-nav-bar>
      </div>
    </div>
    <!-- 出入库记录 -->
    <div class="record_wrap" v-for="(v, k) in items" :key="k">
      <div class="record_cont">
        <div class="flexlr">
          <div class="linh fs-18">{{ $route.query.name }}</div>
          <div class="linh">
            {{ v.status == 0 ? "- " : "+" }}{{ v.number }}
          </div>
        </div>
        <div class="flexlr">
            <div class="linh">价格：{{v.price}}</div>
       <div class="text_gray" v-if="v.status == 0">
          <div class="linh " v-if="v.act == 1">正常扣掉</div>
          <div class="linh" v-if="v.act == 2">浪费掉</div>
          <div class="linh" v-if="v.act == 3">消耗掉</div>
        </div>
        <div class="linh text_gray" v-else>入库</div>
        </div>

        <div class="linh">到期日：{{v.life || '无'}}</div>
        <div class="fs-14  linh">操作日期：{{ v.updated_at }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      items: [],
    };
  },
  mounted() {
    this.getItemDetail();
  },
  methods: {
    getItemDetail() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token,
        },
        url: this.$build + "/api/menu/" + this.$route.query.id + "/detail",
      })
        .then((res) => {
          console.log(res.data.data);
          // status  1 入库 0 出库
          // act 行为：【1： 正常扣掉，2：浪费掉，3：消耗掉】0：入库时没有记录
          if (res.data.status == 200) {
            this.items = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item],
              });
            }
          }
        })
        .catch((err) => {
          this.$toast({
            type: "fail",
            message: this.$t("ShopList.message"),
          });
        });
    },
  },
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-nav-bar__left {
  padding: 0;
  left: -4px;
}
/deep/ .van-nav-bar__right {
  padding: 0;
}
/deep/ .van-cell-group--inset {
  margin: 0;
  margin-top: 15px;
}
.PlatformDetail {
  width: 100%;
  /* min-height: 100vh; */
  background: #f3f3f3;
}
.record_wrap {
  /* border: 1px solid red; */
  border-bottom:1px solid rgb(235, 237, 240);
  background: white;
}
.record_cont {
  /* border: 1px solid green; */
  padding: 10px 16px;
}
.linh{
  line-height: 24px;
}
</style>


// WEBPACK FOOTER //
// src/Platform/ItemDetails.vue